import OrderDetails from './OrderDetails';
export default OrderDetails;
export { default as OrderDetails } from './OrderDetails';